import ACTION_ITEMS from './actionItems';

const initialState = {
  authenticated: false,
  isLoading: false,
  message: '',
};

export const loginReducer = (state = initialState, action) => {
  let newState;
  switch (action.type) {
    case ACTION_ITEMS.LOGIN.MESSAGE.SET:
      newState = { ...state, message: action.payload.message };
      break;

    case ACTION_ITEMS.LOGIN.IS_LOADING.SET:
      newState = { ...state, isLoading: action.payload.isLoading };
      break;

    case ACTION_ITEMS.LOGIN.AUTHENTICATED.SET:
      newState = { ...state, authenticated: action.payload };
      break; 

    default:
      newState = state;
      break;
  }

  return newState;
};
